import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-video-intro-block',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './video-intro-block.component.html',
  styleUrls: ['./video-intro-block.component.less']
})
export class VideoIntroBlockComponent {
  @Input() data: any; 

  getArticleHref(ctaArticle: any): string | null {
    return ctaArticle?.link?.url || ctaArticle?.pdf?.url || null;
  }

  getArticleTarget(ctaArticle: any): '_blank' | '_self' {
    return ctaArticle?.pdf || ctaArticle?.link?.openInNewTab ? '_blank' : '_self';
  }

  getArticleRel(ctaArticle: any): string | null {
    return this.getArticleTarget(ctaArticle) === '_blank' ? 'noopener noreferrer' : null;
  }

  getArticleCtaText(ctaArticle: any): string | null {
    return ctaArticle?.link?.text || ctaArticle?.downloadPdfLinkText || null;
  }
}
